// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AuthIndicator-container-2UTJ_{-webkit-filter:blur(5px);filter:blur(5px)}", ""]);
// Exports
exports.locals = {
	"container": "AuthIndicator-container-2UTJ_"
};
module.exports = exports;
